export const shapes = {
  Round: 'Ronde',
  round: 'Ronde'
};

export const metal = {
  'copper-nickel': 'Cuivre-nickel',
  copper: 'Cuivre',
  nickel: 'Nickel',
  silver: 'Argent',
  gold: 'Or',
  'brass plated steel': 'Plaqué laiton'
};
